import { get } from 'lodash'
import React from 'react'
import { Alert } from 'react-bootstrap'
import Enrollee from './enrollee'

const Enrollees = ({
    experience = {}
}) => {
    const renderEnrollee = (user, key) => (<Enrollee key={key} user={user} />)
    const enrollees = get(experience, 'enrollees', [])
    return (
        <Alert
            variant='primary'
            style={{
                display: 'flex',
                flexWrap: 'wrap',
            }}
        >
            {enrollees.map(renderEnrollee)}
        </Alert>
    )
}

export default Enrollees